export const UPDATE_GB_FEATURES = 'UPDATE_GB_FEATURES';
export const setGbFeatures = (features) => ({
  type: UPDATE_GB_FEATURES,
  payload: features,
});
